import React, { Component } from 'react';
import { BrowserRouter as Router ,Switch, Route } from 'react-router-dom';

import Countdown from './countdown/Countdown';
import Stopwatch from './stopwatch/Stopwatch';
import Timer from './timer/Timer';
import Home from './Home';
import NavigationBar from './NavigationBar';
import Footer from './Footer';
import Reminder from './reminder/Reminder';
import Goal from './goals';


import '../stylesheets/App.css';

class App extends Component {
    constructor(props){
        super(props);
        this.state = {
            'deadline':'December 25,2018',
            'newDeadline':undefined

        }
    }

    render(){
        return(
        <Router>
        <div>
        <NavigationBar />
            <div >
            <Switch>
               <Route exact path='/' component={Home} />
               <Route exact path='/time/countdown' component={Countdown} />
               <Route exact path='/time/stopwatch' component={Stopwatch }/>
               <Route exact path='/time/timer' component={Timer}/>
               <Route exact path='/reminder' component={Reminder}/>
               <Route exact path='/goal' component={Goal} />
            </Switch>
            </div>
        <Footer />
        </div>
        </Router>
        )
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/App.jsx